import {Button, Avatar, Card, Flex, Text, CallRecordingIcon, Tooltip, RedbangIcon, LocationIcon, ExclamationTriangleIcon, Alert } from "@fluentui/react-northstar";
import { UsersData } from "./DevicesViewTab";
import { TwoWayVideo, IntercomIcon, PagerIcon, CameraIcon} from "./CardsIcons";
import {ReactElement } from "react";
import  "./DeviceCard.css"

interface DeviceCardUserProps {
    users: UsersData;
    themeString: string;
    setupCall(userPrincipalName: string): void
  }

  const DeviceCard = ({ users, setupCall, themeString }: DeviceCardUserProps) => {

    const { enabled, userPrincipalName, deviceDescription, incomingCalls, recorded, twoWayVideo, applicationInstanceStatus, location, type, isOnline } = users;
    const themeColorSvgIcon = themeString !== 'default' ? 'white' : 'black'

    const createElementWithTooltip = (text: string, Component: ReactElement) => {

        let msg: string | null = text;

        switch (msg) {
            case 'not enabled':
                msg = 'Device is not Licensed. Please contact your administrator'
                break;
            case 'notAssigned':
                msg = "Cannot connect to device because device is not configured in Microsoft Teams. Please contact your administrator."
                break;
            case 'notUpToDate':
                msg = "Device configuration in Microsoft Teams is not up-to-date. Please contact your administrator."
                break;
            case '2-way':
                msg = " 2-way video supported"
                break;
            case 'recorded':
                msg = 'Device is recorded'
                break;
            case 'intercom':
            case 'pager':
            case 'camera':
                msg = text[0]?.toUpperCase() + text?.slice(1)
                break;
            default:
                msg = null
        }
        return <Tooltip unstable_pinned={true} unstable_disableTether='all' pointing position='below' align="center" subtle={false} content={msg} trigger={Component}/>
    }

    const setStatusIcon = (type: string | undefined) => {

        switch (type) {
            case 'camera':
                return createElementWithTooltip(type, <CameraIcon size="large" style={{marginTop: 2, color: `black`}}/>)
            case 'intercom':
                return createElementWithTooltip(type, <IntercomIcon style={{marginTop: 2, fill: `black`}}/>)
            case 'pager':
                return createElementWithTooltip(type, <PagerIcon styles={{fill: `black`}}/>)
            default:
               return null
        }
    }

    const userTypeDevice = setStatusIcon(type)

    return (
        <Card aria-roledescription="card avatar"
            className={`device-card ${themeString === 'dark' ? themeString : ''}`}
            variables={{backgroundColorHover: 'none'}}
            style={{ border: `${themeString === 'contrast' ? '1px solid rgb(26, 235, 255)' : ''}` }}>
            <Card.Header>
                <div className="status-icons">
                    <div>
                        {applicationInstanceStatus === 'notAssigned' && createElementWithTooltip('notAssigned', <RedbangIcon className={`redbangicon ${themeString}`} />)}
                        {applicationInstanceStatus === 'notUpToDate' && createElementWithTooltip('notUpToDate', <RedbangIcon className={`redbangicon ${themeString}`} />)}
                        {twoWayVideo && createElementWithTooltip('2-way', <TwoWayVideo style={{ marginLeft: 5, fill: `${themeColorSvgIcon}`}} />)}
                        {recorded && createElementWithTooltip('recorded', <CallRecordingIcon style={{ marginLeft: 5, color: 'red' }}/>)}
                    </div>
                </div>
                <Flex gap="gap.small" 
                className="user-description">
                    <Avatar size="larger" 
                    status={{
                        color: !isOnline ? 'gray' : 'green',
                        title: !isOnline ? 'Offlain' : 'Online'
                    }}
                    icon={userTypeDevice} 
                    name={!userTypeDevice ? deviceDescription : ''}/>
                    <Flex column>
                        <Text content={deviceDescription} weight="bold" />
                        <Text style={{marginTop: 2}} content={location && <><LocationIcon style={{marginRight: 2, color: 'grey', verticalAlign: 'baseline'}}/>{location}</>} size="medium" /> 
                    </Flex>
                </Flex>
            </Card.Header>
            {incomingCalls && enabled && !!isOnline && createElementWithTooltip(`${applicationInstanceStatus === 'notAssigned' ? applicationInstanceStatus : null}`,
                <Button
                    className={`device-btn ${themeString}`}
                    disabledFocusable={!userPrincipalName || !enabled || applicationInstanceStatus === 'notAssigned'}
                    onClick={() => setupCall(userPrincipalName || '')}
                    content='Connect'
                />
            )}
            {!enabled && <Alert
                warning
                styles={{paddingLeft: 35, paddingRight: 0, paddingTop: 5, paddingBottom: 5}}
                icon={<ExclamationTriangleIcon/>}
                header="Device is not Licensed"
            />}
            {!isOnline && enabled && <Alert
                warning
                styles={{paddingLeft: 70, paddingTop: 5, paddingBottom: 5}}
                header="Device is offline"
            />}
        </Card>
    )
}

export default DeviceCard